import { render, staticRenderFns } from "./loko_export.vue?vue&type=template&id=42fb37e6&scoped=true&"
import script from "./loko_export.vue?vue&type=script&lang=js&"
export * from "./loko_export.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42fb37e6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/host/getorder/api/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('42fb37e6')) {
      api.createRecord('42fb37e6', component.options)
    } else {
      api.reload('42fb37e6', component.options)
    }
    module.hot.accept("./loko_export.vue?vue&type=template&id=42fb37e6&scoped=true&", function () {
      api.rerender('42fb37e6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/app/components/aggregators/loko/loko_export.vue"
export default component.exports